<mat-card class="m-b-15">
  <button
    mat-flat-button
    color="primary"
    (click)="handleClickDescargaPlantilla()"
    [disabled]="loading">
    <mat-icon>cloud_download</mat-icon>
    Decargar plantilla
  </button>

  <div class="row">
    <div class="col-md-12">
      <div class="display-flex m-t-15 m-b-15">
        <div class="flex-1">
          <lib-form-control
            label="Archivo a cargar"
            variant="text"
            placeholder
            controlName="rutaArchivo"
            [formGroupParent]="form"
            [disabled]="true">
          </lib-form-control>
          <input
            #inputFile
            class="file-input"
            type="file"
            (change)="handleChangeFile($event)">
        </div>
        <button
          *ngIf="!selectedFile"
          class="button-attach-file"
          mat-flat-button
          color="primary"
          (click)="handleAttachFile()">
          <mat-icon>attach_file</mat-icon>
          seleccionar
        </button>
        <button
          *ngIf="selectedFile"
          class="button-attach-file"
          mat-flat-button
          color="primary"
          (click)="handleDeleteFile()">
          <mat-icon>delete</mat-icon>
          Quitar archivo
        </button>
      </div>

    </div>
  </div>

  <div class="text-center">
    <button
      class="m-l-5 m-r-5"
      mat-flat-button
      color="primary"
      [disabled]="!selectedFile"
      (click)="handleUploadFile()">
      <mat-icon>cloud_upload</mat-icon>
      Cargar
    </button>

    <button
      *ngIf="!hideButtonRegresar"
      class="m-l-5 m-r-5"
      mat-stroked-button
      color="primary"
      (click)="regresar.emit()">
      <mat-icon>arrow_back</mat-icon>
      Regresar
    </button>
  </div>

</mat-card>
